import { AbstractControl, ValidatorFn } from '@angular/forms';

export function userName(): ValidatorFn {
    const usernameRe: RegExp = new RegExp(/^[a-zA-Z0-9_.-]*$/);

    return (control: AbstractControl): { [key: string]: any } | null =>
        (control.value && !usernameRe.test(control.value) && { userName: true }) || null;
}
